<template>
    <div class="notifications-list-skeleton-wrapper">
        <div class="notifications-list-skeleton" v-if="isLoading">
            <div v-for="i in itemsCount" :key="i" class="notification-item">
                <div class="notification-content">
                    <div class="skeleton-block long"></div>
                    <div class="skeleton-block short"></div>
                </div>
            </div>
        </div>
        <slot v-else />
    </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
    itemsCount: {
      type: Number,
      default: 6,
    },
  },
};
</script>

<style lang="scss" scoped>
.notifications-list-skeleton {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
    background: #fff;
    border-radius: 4px;

    &-wrapper {
        height: 100%;
    }
}

.notification-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
}

.notification-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.skeleton-block {
    border-radius: 4px;
    background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
    background-size: 200% 100%;
    animation: shimmer 1.4s infinite;

    &.long {
        width: 80%;
        height: 14px;
    }

    &.short {
        width: 50%;
        height: 10px;
    }
}

.data-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
}

.empty-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: -18px;
  height: 300px;
}

@keyframes shimmer {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}
</style>
